import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  border: solid 1px #00000017;
  border-radius: 8px;
  padding: 8px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 500;
  color: #0f0f1e99;
`;

export const Span = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #0f0f1e99;
`;
